/* IPERTECH 2026 — PRODUCT PAGE v4 (varianti real-time + click resiliente + swipe gallery mobile) */
(function(){
  'use strict';
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    document.querySelectorAll('[data-ipt-pp]').forEach(initPP);
  });
  function initPP(root){
    initGallery(root);
    initQty(root);
    initTabs(root);
    initCountdown(root);
    initStickyAtc(root);
    initFav(root);
    initVariants(root);
    initShippingEstimate(root);
    initTrustRotator(root);
    initUrgency(root);
  }

  /* ---- URGENCY (singolare/plurale corretto) ---- */
  function iptUrgText(urgEl, qty){
    var lbl = urgEl.getAttribute('data-urg-label') || 'Solo';
    var sfx = urgEl.getAttribute('data-urg-suffix') || 'pezzi disponibili — prenotalo ora';
    if(qty === 1){ sfx = sfx.replace('pezzi', 'pezzo').replace('disponibili', 'disponibile'); }
    return lbl + ' ' + qty + ' ' + sfx;
  }
  function initUrgency(root){
    var urgEl = root.querySelector('[data-ipt-pp-urg]');
    if(!urgEl) return;
    var m = (urgEl.textContent || '').match(/\d+/);
    if(m) urgEl.textContent = iptUrgText(urgEl, parseInt(m[0], 10));
  }

  /* ---- DYNAMIC SHIPPING ESTIMATE ---- */
  function initShippingEstimate(root){
    var w = root.querySelector('[data-ipt-ship]');
    if(!w) return;
    var costEl = w.querySelector('[data-ipt-ship-cost]');
    var datesEl = w.querySelector('[data-ipt-ship-dates]');
    if(!costEl || !datesEl) return;
    var variants = null;
    var dataEl = root.querySelector('script[data-ipt-pp-variants]');
    if(dataEl){ try { variants = (JSON.parse(dataEl.textContent) || {}).variants || null; } catch(e){ variants = null; } }
    var idInput = root.querySelector('[data-ipt-pp-id-select]');
    function num(attr, fallback){ var n = parseFloat(w.getAttribute(attr)); return isNaN(n) ? fallback : n; }
    function fmtMoney(eur){
      try { return new Intl.NumberFormat('it-IT', {style:'currency', currency: w.getAttribute('data-currency') || 'EUR'}).format(eur); }
      catch(e){ return '€' + eur.toFixed(2).replace('.', ','); }
    }
    function addBusinessDays(start, days){
      var d = new Date(start.getTime()), added = 0;
      while(added < days){ d.setDate(d.getDate() + 1); var wd = d.getDay(); if(wd !== 0 && wd !== 6) added++; }
      return d;
    }
    function fmtDate(d){
      var dd = ('0' + d.getDate()).slice(-2), mm = ('0' + (d.getMonth() + 1)).slice(-2);
      return dd + '/' + mm + '/' + d.getFullYear();
    }
    function compute(){
      var priceEur = (num('data-price', 0)) / 100;
      var weight = num('data-weight', 0);
      var country = (w.getAttribute('data-country') || 'IT').toUpperCase();
      var freeThr = num('data-free-threshold', 0);
      var base = num('data-base', 0);
      var perKg = num('data-per-kg', 0);
      var intl = num('data-intl', 0);
      var cost;
      if(freeThr > 0 && priceEur >= freeThr){ cost = 0; }
      else { cost = base + perKg * weight; if(country !== 'IT') cost += intl; }
      if(cost <= 0){ costEl.textContent = w.getAttribute('data-free-label') || 'Gratuita'; costEl.classList.add('is-free'); }
      else { costEl.textContent = fmtMoney(cost); costEl.classList.remove('is-free'); }
      var proc = Math.round(num('data-proc', 1));
      var tmin = Math.round(num('data-tmin', 2));
      var tmax = Math.round(num('data-tmax', 4));
      var today = new Date();
      var dmin = addBusinessDays(today, proc + tmin);
      var dmax = addBusinessDays(today, proc + tmax);
      datesEl.textContent = fmtDate(dmin) + ' - ' + fmtDate(dmax);
    }
    function syncVariant(){
      if(variants && idInput){
        var id = parseInt(idInput.value, 10);
        for(var i = 0; i < variants.length; i++){
          if(variants[i].id === id){
            if(variants[i].weight != null) w.setAttribute('data-weight', variants[i].weight);
            if(variants[i].price != null) w.setAttribute('data-price', variants[i].price);
            break;
          }
        }
      }
      compute();
    }
    compute();
    if(idInput) idInput.addEventListener('change', syncVariant);
  }

  /* ---- GALLERY ---- */
  function initGallery(root){
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ipt-pp-thumb]'));
    var mainImg = root.querySelector('[data-ipt-pp-main-img]');
    if(!mainImg) return;
    function currentIndex(){
      for(var k = 0; k < thumbs.length; k++){ if(thumbs[k].classList.contains('is-active')) return k; }
      return 0;
    }
    function activate(i){
      if(!thumbs.length) return;
      if(i < 0) i = thumbs.length - 1;
      if(i >= thumbs.length) i = 0;
      var t = thumbs[i];
      switchMainImage(root, t.getAttribute('data-full'));
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
      try { t.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){}
    }
    thumbs.forEach(function(t, i){
      t.addEventListener('click', function(){ activate(i); });
    });
    /* Swipe orizzontale sull'immagine principale (mobile) */
    var stage = root.querySelector('.ipt-pp__gal-main') || mainImg;
    if(stage && thumbs.length > 1){
      var sx = 0, sy = 0, tracking = false;
      stage.addEventListener('touchstart', function(e){
        if(e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, {passive:true});
      stage.addEventListener('touchend', function(e){
        if(!tracking) return; tracking = false;
        var c = e.changedTouches[0];
        var dx = c.clientX - sx, dy = c.clientY - sy;
        /* swipe valido solo se orizzontale e ampio abbastanza */
        if(Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        activate(currentIndex() + (dx < 0 ? 1 : -1));
      }, {passive:true});
    }
  }
  function switchMainImage(root, src){
    if(!src) return;
    var mainImg = root.querySelector('[data-ipt-pp-main-img]');
    if(!mainImg) return;
    mainImg.style.opacity = '0';
    setTimeout(function(){
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      mainImg.style.opacity = '1';
    }, 100);
  }

  /* ---- QTY ---- */
  function initQty(root){
    root.querySelectorAll('[data-ipt-pp-qty]').forEach(function(group){
      var input = group.querySelector('input');
      var dec = group.querySelector('[data-act="dec"]');
      var inc = group.querySelector('[data-act="inc"]');
      if(!input) return;
      function clamp(v){
        var min = parseInt(input.min || '1', 10);
        var max = parseInt(input.max || '99', 10);
        return Math.max(min, Math.min(max, v || min));
      }
      dec && dec.addEventListener('click', function(){ input.value = clamp(parseInt(input.value, 10) - 1); });
      inc && inc.addEventListener('click', function(){ input.value = clamp(parseInt(input.value, 10) + 1); });
      input.addEventListener('blur', function(){ input.value = clamp(parseInt(input.value, 10)); });
    });
  }

  /* ---- TABS ---- */
  function initTabs(root){
    var tabs = root.querySelectorAll('[data-ipt-pp-tab]');
    var panels = root.querySelectorAll('[data-ipt-pp-panel]');
    if(!tabs.length) return;
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var key = tab.getAttribute('data-ipt-pp-tab');
        tabs.forEach(function(t){ t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-ipt-pp-panel') === key); });
      });
    });
  }

  /* ---- COUNTDOWN ---- */
  function initCountdown(root){
    var el = root.querySelector('[data-ipt-pp-countdown]');
    if(!el) return;
    var end = new Date(el.getAttribute('data-end')).getTime();
    if(isNaN(end)) return;
    var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]');
    var mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
    function pad(n){ return n < 10 ? '0' + n : '' + n; }
    function tick(){
      var diff = end - Date.now();
      if(diff <= 0){ el.style.display = 'none'; return; }
      if(dEl) dEl.textContent = Math.floor(diff / 86400000) + 'g';
      if(hEl) hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if(mEl) mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if(sEl) sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---- STICKY ATC ---- */
  function initStickyAtc(root){
    var bar = root.querySelector('[data-ipt-pp-msa]');
    var bb = root.querySelector('[data-ipt-pp-bb]');
    if(!bar || !bb) return;
    var ticking = false;
    function check(){
      var r = bb.getBoundingClientRect();
      bar.classList.toggle('is-visible', (r.top + r.height) < 80 || r.top > window.innerHeight);
      ticking = false;
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    check();
    var msaCta = bar.querySelector('[data-ipt-pp-msa-cta]');
    if(msaCta){
      msaCta.addEventListener('click', function(){
        var atc = root.querySelector('[data-ipt-pp-atc]');
        if(!atc) return;
        if(atc.disabled){
          /* Prodotto esaurito: scorri al buy-box per mostrare il messaggio */
          atc.scrollIntoView({behavior:'smooth', block:'center'});
          return;
        }
        /* Prodotto disponibile: triggera direttamente il click sul pulsante ATC
           (il cart drawer JS lo intercetta in capture e chiama submitAdd) */
        atc.click();
      });
    }
  }

  /* ---- WISHLIST ---- */
  function initFav(root){
    var btn = root.querySelector('[data-ipt-pp-fav]');
    if(!btn) return;
    var handle = btn.getAttribute('data-handle');
    if(!handle) return;
    var KEY = 'ipt_wishlist';
    function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
    function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
    function sync(){ btn.classList.toggle('is-active', read().indexOf(handle) !== -1); }
    sync();
    btn.addEventListener('click', function(){
      var a = read(), i = a.indexOf(handle);
      if(i === -1) a.push(handle); else a.splice(i, 1);
      write(a); sync();
    });
  }

  /* ---- HELPERS ---- */
  function formatMoney(cents){
    if(cents === null || cents === undefined) return '';
    try {
      return new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'}).format(cents / 100);
    } catch(e){
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }
  function shopifyImgUrl(src, size){
    if(!src) return src;
    size = size || '1200x';
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  /* ---- VARIANTI ---- */
  function initVariants(root){
    var buttons = root.querySelectorAll('.ipt-pp__opt-val');
    if(!buttons.length) return;
    var idSelect = root.querySelector('[data-ipt-pp-id-select]');

    /* JSON dati varianti — opzionale: senza, il click sincronizza solo UI/select */
    var data = null;
    var dataEl = root.querySelector('script[data-ipt-pp-variants]');
    if(dataEl){
      try { data = JSON.parse(dataEl.textContent); }
      catch(e){ if(window.console) console.warn('[ipt-pp] varianti JSON non valido', e); data = null; }
    }
    var variants = data && data.variants ? data.variants : null;
    var optionNames = data && data.options ? data.options : null;

    function getSelected(){
      var sel = {};
      root.querySelectorAll('.ipt-pp__opt').forEach(function(group){
        var active = group.querySelector('.ipt-pp__opt-val.is-active');
        if(active) sel[active.getAttribute('data-opt-name')] = active.getAttribute('data-opt-value');
      });
      return sel;
    }

    function findVariant(sel){
      if(!variants || !optionNames) return null;
      for(var i = 0; i < variants.length; i++){
        var v = variants[i], match = true;
        for(var j = 0; j < optionNames.length; j++){
          if(v['option' + (j + 1)] !== sel[optionNames[j]]){ match = false; break; }
        }
        if(match) return v;
      }
      return null;
    }

    function updateUI(v){
      if(!v) return;

      if(idSelect){
        idSelect.value = v.id;
        idSelect.dispatchEvent(new Event('change', {bubbles:true}));
      }

      var nowEl = root.querySelector('.ipt-pp__now');
      var wasEl = root.querySelector('.ipt-pp__was');
      var offerEl = root.querySelector('[data-ipt-pp-offer]');
      var pctValEl = root.querySelector('[data-ipt-pp-pct]');
      if(nowEl) nowEl.textContent = formatMoney(v.price);

      var hasSale = v.compare_at_price && v.compare_at_price > v.price;
      if(wasEl){ wasEl.textContent = hasSale ? formatMoney(v.compare_at_price) : ''; wasEl.style.display = hasSale ? '' : 'none'; }
      if(hasSale && pctValEl){
        var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        pctValEl.textContent = '-' + pct + '%';
      }
      if(offerEl) offerEl.style.display = hasSale ? '' : 'none';

      var msaPrice = root.querySelector('.ipt-pp__msa-price');
      if(msaPrice) msaPrice.textContent = formatMoney(v.price);

      var klarnaB = root.querySelector('[data-ipt-pp-klarna-price]');
      if(klarnaB) klarnaB.textContent = formatMoney(Math.round(v.price / 3));

      var skuEl = root.querySelector('[data-ipt-pp-sku]');
      if(skuEl) skuEl.textContent = v.sku ? 'SKU: ' + v.sku : '';

      var atcEl = root.querySelector('[data-ipt-pp-atc]');
      if(atcEl){
        atcEl.disabled = !v.available;
        var span = atcEl.querySelector('span');
        if(span){
          span.textContent = v.available
            ? (atcEl.getAttribute('data-label-available') || 'Aggiungi al carrello')
            : (atcEl.getAttribute('data-label-out') || 'Esaurito');
        }
      }

      var urgEl = root.querySelector('[data-ipt-pp-urg]');
      if(urgEl){
        var threshold = parseInt(urgEl.getAttribute('data-urg-threshold') || '5', 10);
        var lbl = urgEl.getAttribute('data-urg-label') || 'Solo';
        var sfx = urgEl.getAttribute('data-urg-suffix') || 'pezzi disponibili — prenotalo ora';
        var showUrg = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= threshold;
        urgEl.textContent = iptUrgText(urgEl, v.inventory_quantity);
        urgEl.style.display = showUrg ? '' : 'none';
      }

      if(v.featured_image && v.featured_image.src){
        switchMainImage(root, shopifyImgUrl(v.featured_image.src, '1200x'));
      }

      /* Aggiorna URL ?variant=ID senza reload */
      if(window.history && history.replaceState){
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        } catch(e){}
      }
    }

    /* Click su ogni pulsante pill — SEMPRE registrato anche senza JSON */
    buttons.forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var name = btn.getAttribute('data-opt-name');
        var val = btn.getAttribute('data-opt-value');

        /* 1. UI: attiva il pulsante cliccato nel suo gruppo */
        root.querySelectorAll('.ipt-pp__opt-val[data-opt-name="' + name + '"]').forEach(function(b){
          var on = (b === btn);
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });

        /* 2. Aggiorna la label visibile (es. "Colore: Blu") */
        var optWrap = btn.closest('.ipt-pp__opt');
        if(optWrap){
          var lbl = optWrap.querySelector('.ipt-pp__opt-lbl span');
          if(lbl) lbl.textContent = val;
        }

        /* 3. Sincronizza <select hidden name="options[Colore]"> per il form submit */
        var optSel = root.querySelector('select[name="options[' + name + ']"]');
        if(optSel){ optSel.value = val; optSel.dispatchEvent(new Event('change', {bubbles:true})); }

        /* 4. Aggiorna prezzo/availability se JSON varianti disponibile */
        var v = findVariant(getSelected());
        if(v) updateUI(v);
      });
    });
  }

  /* ---- TRUST & SOCIAL PROOF ROTATOR ---- */
  function initTrustRotator(root){
    var box = root.querySelector('[data-ipt-trust]');
    if(!box) return;
    var items = Array.prototype.slice.call(box.querySelectorAll('.ipt-pp__trust-item'));
    if(items.length === 0) return;
    box.classList.remove('js-preload');
    /* ordine casuale ad ogni caricamento pagina (Fisher-Yates) */
    var order = items.map(function(_, i){ return i; });
    for(var i = order.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
    }
    items.forEach(function(el){ el.classList.remove('is-active'); });
    var pos = 0;
    items[order[0]].classList.add('is-active');
    if(items.length < 2) return;
    var ms = (parseFloat(box.getAttribute('data-interval')) || 10) * 1000;
    if(ms < 2000) ms = 2000;
    setInterval(function(){
      items[order[pos]].classList.remove('is-active');
      pos = (pos + 1) % order.length;
      items[order[pos]].classList.add('is-active');
    }, ms);
  }
})();
